import { render, staticRenderFns } from "./canTheWheelBeRiggedCard.vue?vue&type=template&id=6cc0642a&scoped=true"
import script from "./canTheWheelBeRiggedCard.vue?vue&type=script&lang=js"
export * from "./canTheWheelBeRiggedCard.vue?vue&type=script&lang=js"
import style0 from "./canTheWheelBeRiggedCard.vue?vue&type=style&index=0&id=6cc0642a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc0642a",
  null
  
)

export default component.exports